export { default as Editar } from './Editar';
